export default __webpack_public_path__ + "static/media/geoLocalisation.3f6b953e.png";